	@if (toasts() && toasts()!.length > 0) {
	@for (toast of toasts()!; track toast.id) {
	<app-toast class="toast-item" animate.enter="toast-item--enter" animate.leave="toast-item--leave" [id]="toast.id!" [status]="toast.status ?? 'neutral'">
		 <ng-container
			*ngComponentOutlet="getMatchingComponent(toast.kind); inputs: getMatchingInputs(toast.kind, toast)" />
	 </app-toast>
	 }
	}